/**
 * Alert Workflow Actions - Phase 15 (Backend-connected)
 *
 * Delegates all actions to /api/alerts/ backend endpoints
 * via the alertStore module.
 */
import {
  acknowledgeAlert as storeAcknowledge,
  escalateAlert as storeEscalate,
  resolveAlert as storeResolve,
  dismissAlert as storeDismiss,
  addAlertNote as storeAddNote,
} from './alertStore';

export async function acknowledgeAlert(alertId, actor = {}) {
  try {
    const result = await storeAcknowledge(alertId, '', actor.userId || actor.name || '');
    recordAlertAction('acknowledged', result, actor);
    return result;
  } catch (err) {
    console.error('[AlertWorkflow] Acknowledge failed:', err.message);
    return null;
  }
}

export async function escalateAlert(alertId, actor = {}, note = null) {
  try {
    const result = await storeEscalate(alertId, note || '', actor.userId || actor.name || '');
    recordAlertAction('escalated', result, actor);
    return result;
  } catch (err) {
    console.error('[AlertWorkflow] Escalate failed:', err.message);
    return null;
  }
}

export async function resolveAlert(alertId, actor = {}, note = null) {
  try {
    const result = await storeResolve(alertId, note || '', actor.userId || actor.name || '');
    recordAlertAction('resolved', result, actor);
    return result;
  } catch (err) {
    console.error('[AlertWorkflow] Resolve failed:', err.message);
    return null;
  }
}

export async function dismissAlert(alertId, actor = {}, note = '') {
  if (!note) {
    console.warn('[AlertWorkflow] Dismissal requires a note');
    return null;
  }
  try {
    const result = await storeDismiss(alertId, note, actor.userId || actor.name || '');
    recordAlertAction('dismissed', result, actor);
    return result;
  } catch (err) {
    console.error('[AlertWorkflow] Dismiss failed:', err.message);
    return null;
  }
}

export async function addAlertNote(alertId, note, actor = {}) {
  if (!note) return null;
  try {
    const result = await storeAddNote(alertId, note, actor.userId || actor.name || '');
    recordAlertAction('note_added', result, actor);
    return result;
  } catch (err) {
    console.error('[AlertWorkflow] Add note failed:', err.message);
    return null;
  }
}

// Legacy compat stubs
export async function suppressAlert() { return null; }
export async function reopenAlert() { return null; }

function recordAlertAction(action, alert, actor = {}) {
  console.log('[AlertWorkflow]', {
    action,
    alertId: alert?.alertId,
    alertType: alert?.alertType,
    actor: actor?.userId || 'unknown',
  });
}

export default {
  acknowledgeAlert,
  escalateAlert,
  resolveAlert,
  dismissAlert,
  addAlertNote,
  suppressAlert,
  reopenAlert,
};
